import React from 'react';
import { twMerge } from 'tailwind-merge';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'solid' | 'ghost' | 'outline';
  size?: 'sm' | 'md' | 'lg';
}
export function Button({
  variant = 'solid',
  size = 'md',
  className,
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-colors rounded-md focus:outline-none focus:ring-2 focus:ring-techblue focus:ring-offset-2';
  const variants = {
    solid: 'bg-techblue text-white hover:bg-blue-700 border border-transparent',
    ghost: 'bg-transparent text-navy hover:bg-slate-100 border border-transparent dark:text-white dark:hover:bg-slate-800',
    outline: 'bg-transparent text-white border border-slate-600 hover:bg-slate-800'
  };
  const sizes = {
    sm: 'h-9 px-3 text-sm',
    md: 'h-10 px-4 py-2',
    lg: 'h-12 px-6 text-lg'
  };
  return <button className={twMerge(baseStyles, variants[variant], sizes[size], className)} {...props} data-id="element-6">
      {children}
    </button>;
}